(() => {
const $82b8674e8d870df0$var$lib = {
    selectors: {
        rideshare: '.rideshare',
        scroll: '.rideshare__scroll-up',
        toggle: '.rideshare__toggle',
        footer: 'footer.footer'
    },
    classes: {
        content: 'rideshare--content',
        opened: 'rideshare--opened',
        closed: 'rideshare--closed',
        scrollUp: 'rideshare--scroll-up',
        scrollTop: 'rideshare--scroll-top',
        scrollBottom: 'rideshare--scroll-bottom'
    }
};
let $82b8674e8d870df0$var$lastScrollTop = 0;
let $82b8674e8d870df0$var$showRideshareContent = true;
const $82b8674e8d870df0$var$scrollUpIndicator = document.querySelector($82b8674e8d870df0$var$lib.selectors.scroll);
const $82b8674e8d870df0$var$rideshare = document.querySelector($82b8674e8d870df0$var$lib.selectors.rideshare);
const $82b8674e8d870df0$var$toggle = document.querySelector($82b8674e8d870df0$var$lib.selectors.toggle);
const $82b8674e8d870df0$var$sessionStorageKey = 'rideshareClosed';
// Calculate bottom offset.
const $82b8674e8d870df0$var$footer = document.querySelector($82b8674e8d870df0$var$lib.selectors.footer);
let $82b8674e8d870df0$var$bottomOffset = 0;
if ($82b8674e8d870df0$var$footer) $82b8674e8d870df0$var$bottomOffset = $82b8674e8d870df0$var$footer.getBoundingClientRect().height;
const $82b8674e8d870df0$var$prefersClosedRideshare = ()=>sessionStorage.getItem($82b8674e8d870df0$var$sessionStorageKey);
// Add classes to the rideshare element based on the scroll position.
const $82b8674e8d870df0$var$onScroll = ()=>{
    const classList = $82b8674e8d870df0$var$rideshare.classList;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop === 0) {
        // Page is not scrolled.
        classList.remove($82b8674e8d870df0$var$lib.classes.scrollUp);
        classList.add($82b8674e8d870df0$var$lib.classes.scrollTop);
    } else {
        // Page is scrolled.
        classList.remove($82b8674e8d870df0$var$lib.classes.scrollTop);
        scrollTop > $82b8674e8d870df0$var$lastScrollTop ? classList.remove($82b8674e8d870df0$var$lib.classes.scrollUp) : classList.add($82b8674e8d870df0$var$lib.classes.scrollUp);
        // Close the rideshare if the user scrolls down.
        if ($82b8674e8d870df0$var$lastScrollTop > 200 && $82b8674e8d870df0$var$showRideshareContent) {
            $82b8674e8d870df0$var$showRideshareContent = false;
            $82b8674e8d870df0$var$closeRideshare();
        }
        // Reached the bottom of the page.
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - $82b8674e8d870df0$var$bottomOffset) classList.add($82b8674e8d870df0$var$lib.classes.scrollBottom);
        else classList.remove($82b8674e8d870df0$var$lib.classes.scrollBottom);
    }
    $82b8674e8d870df0$var$lastScrollTop = scrollTop;
};
$82b8674e8d870df0$var$scrollUpIndicator.addEventListener('click', ()=>{
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});
$82b8674e8d870df0$var$onScroll();
window.addEventListener('scroll', $82b8674e8d870df0$var$onScroll);
// Toggle the rideshare content.
if ($82b8674e8d870df0$var$rideshare.classList.contains($82b8674e8d870df0$var$lib.classes.content)) $82b8674e8d870df0$var$toggle.addEventListener('click', ()=>{
    window.toggleRideshare();
});
const $82b8674e8d870df0$var$openRideshare = ()=>{
    $82b8674e8d870df0$var$rideshare.classList.remove($82b8674e8d870df0$var$lib.classes.closed);
    $82b8674e8d870df0$var$rideshare.classList.add($82b8674e8d870df0$var$lib.classes.opened);
};
const $82b8674e8d870df0$var$closeRideshare = (storePreference = false)=>{
    $82b8674e8d870df0$var$rideshare.classList.remove($82b8674e8d870df0$var$lib.classes.opened);
    $82b8674e8d870df0$var$rideshare.classList.add($82b8674e8d870df0$var$lib.classes.closed);
    storePreference && sessionStorage.setItem('rideshareClosed', 1);
};
// Toggle the rideshare content.
window.toggleRideshare = ()=>{
    if ($82b8674e8d870df0$var$rideshare.classList.contains($82b8674e8d870df0$var$lib.classes.closed)) $82b8674e8d870df0$var$openRideshare();
    else $82b8674e8d870df0$var$closeRideshare(true);
};
// Open rideshare if the user is at the top of the page and has not closed the rideshare.
document.addEventListener('DOMContentLoaded', ()=>{
    $82b8674e8d870df0$var$rideshare.hidden = false;
    setTimeout(()=>{
        if ($82b8674e8d870df0$var$lastScrollTop < 200 && !$82b8674e8d870df0$var$prefersClosedRideshare() && $82b8674e8d870df0$var$showRideshareContent) $82b8674e8d870df0$var$openRideshare();
    }, 500);
});

})();
//# sourceMappingURL=rideshare.min.js.map
